import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import CMM from '@nonameapp-core'

Vue.use(Vuex)

console.log("@nonameapp-core", CMM)

/*const requireModule = require.context(`${commonStore}/modules`, true, /index\.js$/) // extract js files inside modules folder
const modules = {}

requireModule.keys().forEach(fileName => {
  const moduleName = fileName.replace(/(\.\/|\/index\.js)/g, '')
  modules[moduleName] = requireModule(fileName).default
})*/

const store = new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.localStorage,
    paths: [
      'auth.user',
      'cart',
      'shops.products',
      //'shops.current.data.services',
      //'shops.productsfilterSelected',
      'global.reservationDate',
      'global.reservationDateForServer'
    ],
  })],
  modules: CMM._store
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js